import { EventBroker } from "@frontend/lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT',
  SAVE: 'SAVE'
}

export const renameJobEventBroker = new EventBroker();
